var _ = require("lodash");

var
  C = require("./Constructors"),
  Var         = C.Var,
  Application = C.Application,
  Lambda      = C.Lambda,
  External    = C.External;

var
  Externals = require("./Externals"),
  ExternalObjectInterpretation = Externals.ExternalObjectInterpretation,
  getExternalMap = Externals.getExternalMap;

var
  FreeVar = require("./FreeVar");

/**
 * replaces each occurence of `v` in `expr` with
 *   another variable `v1` avoiding binding conflicts by applying
 *   alpha-conversion when needed.
 * @param {LambdaTerm} expr - lambda term
 * @param {Var} v - a variable
 * @param {Var} v1 - a variable
 * @return lambda term
 */
function renameVar(expr, v, v1) {
  // a list of variables that are already in use
  var blacklist = [v1];
  // traverse lambda term
  function traverse(e) {
    // rename variable v to v1
    if(e instanceof Var)
      return e == v ? v1 : e;
    // recursively rename v to v1 in both subterms of application
    if(e instanceof Application) {
      var func = traverse(e.func, v, v1);
      var arg  = traverse(e.arg,  v, v1);
      return new Application(func, arg);
    }
    // if lambda abstraction uses the same variable, do not change it
    // otherwise check whether bound variable is in blacklist
    // rename it if needed and go down recursively
    if(e instanceof Lambda) {
      if(e.arg == v) return e;
      if(_.includes(blacklist, e.arg)) {
        var arg  = new Var(e.arg.varType);
        var body = renameVar(e.body, e.arg, arg);
      } else {
        var arg  = e.arg;
        var body = e.body;
      }
      return new Lambda(arg, renameVar(body, v, v1));
    }
    if(e instanceof External) {
      if(ExternalObjectInterpretation[e.objType] === undefined)
        return e;
      var map = getExternalMap(e.objType);
      return new External(
        map(e.object,
          function(nested) {
            return renameVar(nested, v, v1);
          }),
        e.objType, e.termType);
    }
  }
  
  return traverse(expr);
}

/**
 * replaces each occurence of `v` in `expr` with `subexpr`
 *   avoiding binding conflicts by applying alpha-conversion when needed.
 * @param {LambdaTerm} expr - lambda term
 * @param {Var} v - a variable
 * @param {LambdaTerm} subexpr - lambda term
 * @return lambda term
 */
function replaceVar(expr, v, subexpr) {
  // a list of variables that are already in use
  var blacklist = FreeVar(subexpr);
  // traverse lambda term
  function traverse(e) {
    if(e instanceof Var)
      return e == v ? subexpr : e;
    if(e instanceof Application) {
      var func = traverse(e.func, v, subexpr);
      var arg  = traverse(e.arg,  v, subexpr);
      return new Application(func, arg);
    }
    if(e instanceof Lambda) {
      if(e.arg == v) return e;
      if(_.includes(blacklist, e.arg)) {
        var arg  = new Var(e.arg.varType);
        var body = renameVar(e.body, e.arg, arg);
      } else {
        var arg  = e.arg;
        var body = e.body;
      }
      return new Lambda(arg, replaceVar(body, v, subexpr));
    }
    if(e instanceof External) {
      if(ExternalObjectInterpretation[e.objType] === undefined)
        return e;
      var map = getExternalMap(e.objType);
      return new External(
        map(e.object,
          function(nested) {
            return replaceVar(nested, v, subexpr);
          }),
        e.objType, e.termType);
    }
  }
  //
  return traverse(expr);
}

module.exports = {
  renameVar: renameVar,
  replaceVar: replaceVar
};
